export const CREODIAS_LINK = 'https://creodias.sentinel-hub.com/ogc/*';
export const CODE_DE_LINK = 'https://code-de.sentinel-hub.com/ogc/*';
export const AWS_EU_LINK = 'https://services.sentinel-hub.com/ogc/*';
export const MUNDI_LINK = 'https://shservices.mundiwebservices.com/ogc/*';
export const US_WEST_LINK = 'https://services-uswest2.sentinel-hub.com/ogc/*';
